import React from 'react';
import { MDBBadge, MDBCard, MDBCardBody, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';

export class EmployeeManagement extends React.Component {
    render() {
        return (
            <div>
                <h4><b>Employee Management</b></h4>
                <MDBCard style={{marginTop:20}}>
                    <MDBCardBody>
                    <MDBTable responsive>
                        <MDBTableHead>
                            <tr>
                                <th>Employee ID</th>
                                <th>Employee Name</th>
                                <th>Mobile</th>
                                <th>Email</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            <tr>
                                <td>VIS1001</td>
                                <td>Tony</td>
                                <td>9876543210</td>
                                <td>tony@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>Steve</td>
                                <td>9876543210</td>
                                <td>steve@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#F58220'}}>Inactive</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>Peter</td>
                                <td>9876543210</td>
                                <td>peter@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>Bruce</td>
                                <td>9876543210</td>
                                <td>bruce@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>Clarke</td>
                                <td>9876543210</td>
                                <td>clarke@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>Barry</td>
                                <td>9876543210</td>
                                <td>barry@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>Lucifer</td>
                                <td>9876543210</td>
                                <td>lucifer@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>
                            <tr>
                            <td>VIS1001</td>
                                <td>John</td>
                                <td>9876543210</td>
                                <td>john@mail.com</td>
                                <td ><MDBBadge color="none" style={{backgroundColor:'#2E3192'}}>Active</MDBBadge></td>
                                <td><a href="javascript:void(0)">Details</a></td>
                            </tr>    
                        </MDBTableBody>
                        </MDBTable>
                    </MDBCardBody>
                </MDBCard>
            </div>
        )
    }
}

export default EmployeeManagement;
